
// ModalDetalhesFornecedor.js

import React from 'react';
import './ModalDetalhesCliente.css'; // Certifique-se de que o caminho está correto e que o arquivo CSS existe

function ModalDetalhesFornecedor({ fornecedor, fecharDetalhes }) {
    if (!fornecedor) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="fechar" onClick={fecharDetalhes}>&times;</span>
        <h3>Detalhes do Fornecedor</h3>
        <table>
          <tbody>
            <tr>
              <td>Nome:</td>
              <td translate="no">{fornecedor.nomefor}</td>
            </tr>
            <tr>
              <td>Código:</td>
              <td>{fornecedor.codfor}</td>
            </tr>
            <tr>
              <td>CNPJ:</td>
              <td>{fornecedor.cnpjfor}</td>
            </tr>
            <tr>
              <td>Insc.Est.:</td>
              <td>{fornecedor.inscricaoest}</td>
            </tr>
            <tr>
              <td>Celular:</td>
              <td>{fornecedor.celular}</td>
            </tr>
            <tr>
              <td>Telefone:</td>
              <td>{fornecedor.fone}</td>
            </tr>
            <tr>
              <td>E-mail:</td>
              <td translate="no">{fornecedor.email}</td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ModalDetalhesFornecedor;